:host {
  height: -webkit-fill-available; /* For WebKit-based browsers */
  height: 100vh; /* Fallback for other browsers */
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
}

@supports (-webkit-touch-callout: none) {
  :host {
    height: -webkit-fill-available;
  }
}

.wrapper {
  flex: 1;
  padding: calc(7 * var(--spacer)) var(--spacer) calc(4 * var(--spacer)) calc(2 * var(--spacer));
  overflow: hidden;
}

.title {
  margin-bottom: calc(2 * var(--spacer));
  height: calc(4 * var(--spacer));
  display: flex;
  align-items: center;
}
